<template>
    <AppModal :name="name"
              :beforeClose="beforeClose"
              :beforeOpen="beforeOpen"
              :onEnterKeyPress="save"
              :opened="opened"
              width="500">

        <template slot="header">
            Document type name
        </template>

        <template slot="content">
            <div class="text-left">
                <input v-model.trim="dt.name"
                       @input="vuelidateDelayTouch($v.dt.name, touchMap)"
                       autofocus
                       type="text"
                       ref="dtName"
                       id="name"
                       class="form-control"
                       placeholder="Document type name">
                <small v-if="$v.dt.name.$error" class="form-text text-danger">
                    <span v-if="!$v.dt.name.required">This field is required</span>
                </small>
            </div>
        </template>

        <template slot="actions">
            <div class="text-right">
                <button @click="$modal.hide(name)" class="btn btn-link d-inline-block">
                    Close
                </button>
                <button v-loading.btn="isLoading" @click="save" class="btn btn-primary d-inline-block">
                    Save
                </button>
            </div>
        </template>

    </AppModal>
</template>

<script>
import {required} from 'vuelidate/lib/validators'

export default {
    name: 'DtRename',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            touchMap: new WeakMap(),

            dt: {
                name: null,
                uuid: null
            },
            onSave: null,
            isLoading: false
        }
    },
    validations: {
        dt: {
            name: {required}
        }
    },
    methods: {
        beforeClose() {
            this.dt.name = ''
            this.dt.uuid = ''
            this.$v.$reset()
        },

        beforeOpen({params}) {
            this.dt = params.dt
            this.onSave = params.onSave
        },

        opened() {
            this.$nextTick(() => {
                this.$refs.dtName.focus()
            })
        },

        async save() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }
            this.isLoading = true
            if (typeof this.onSave === 'function') {
                await this.onSave(this.dt.name)
            }
            this.isLoading = false
            this.$modal.hide(this.name)
        }
    }
}
</script>

<style scoped>
    button {
        width: 120px;
    }
</style>
